import React from 'react';

import Icon from '@components/icon/Icon.tsx';

import I from '../types.ts';

const renderHead: I['renderHead'] = function () {
    const { article } = this.props;

    return (
        <div className="publicBlogPreview__head _ROW">
            <div className="publicBlogPreview__headInfo _ROW _section">{article?.sectionText}</div>
            <div className="publicBlogPreview__headInfo _ROW">
                <i className="publicBlogPreview__headInfoIcon">
                    <Icon name="blog-view" />
                </i>
                {article.viewCounter || 0}
            </div>
        </div>
    );
};

export default renderHead;
